<div role="list" class="months-row100" #zittingDiv>
    <div class="zitting-row" role="listitem" *ngFor="let zitting of zittingen; trackBy:getZittingId" [id]="zitting.identifier">
        <div class="zitting-group-row" *ngIf="zitting.IsMonthChanged">
            <h2 class="head2" >{{zitting.DatumZitting | date:'MMMM y'}}</h2>
        </div>
        <div class="zitting-data-card">
            <div class="zitting-dag-col theme-fg-color">{{zitting.DatumZitting | date:'EEE' }}</div>
            <div class="zitting-datum-col head5none title theme-fg-color">
                {{zitting.DatumZitting | date:'dd MMM' | uppercase}}
            </div>
            <div class="zitting-jaar-col theme-fg-color">
                {{zitting.DatumZitting | date:'y'}}
            </div>
            <h3 class="zitting-titel-col head4none c2-clickable" attr.aria-label="{{zitting.SoortZitting}} {{zitting.DatumZitting | date:'dd MMM yyyy'}} " tabindex="0"   [class.zitting-inactive]="!zitting.NotificatieVerstuurd" (keydown.enter)="navigateToDetailZitting(zitting)" (click)="navigateToDetailZitting(zitting)">{{zitting.SoortZitting}}</h3>
            <div class="zitting-locatie-col">{{zitting.Plaats}} - {{zitting.Uur}}</div>
        </div>
    </div>
</div>